'use strict';

var _ = require('lodash');
var CompetitorFaresChartSearchDataService = function CompetitorFaresChartSearchDataService($q, restangular, dataRetrieverService, momentService, dataRetrieverConstantsService, daysToDepartureCalculatorService, competitorFaresChartTimeWindowService, currentStateCriteriaService, competitorFaresCommonService) {
  function getDepartureDate(dataRetriever, selectedEntity) {
    if (selectedEntity && selectedEntity.flightDepartureDateMoment) {
      return selectedEntity.flightDepartureDateMoment.startOf('day');
    }
    var dateRangeBrush = dataRetriever.brushFilters().dateRange;
    if (_.isUndefined(dateRangeBrush)) {
      return _.find(currentStateCriteriaService.getSearchCriteria().rules, function (r) {
        return r.field && r.field.toLowerCase().indexOf('departureDate'.toLowerCase()) > -1;
      }).leftOperand.startOf('day');
    }
    return dateRangeBrush.filterArguments[0][0].from.startOf('day');
  }
  function getTodayDtd(origin, date) {
    return restangular.one('ancillary').one('airport').one('tzOffsets').one(origin).withHttpConfig({
      cache: true
    }).get().then(function (airportTimeZoneData) {
      var now = momentService.now(momentService.FIELD.DEPARTURE_DATE);
      return daysToDepartureCalculatorService.calculate(now, airportTimeZoneData, date);
    });
  }
  function getAllServices(dataRetriever, screen, mode) {
    if (screen !== dataRetrieverConstantsService.MARKET_SCREEN || mode !== dataRetrieverConstantsService.SERVICE_MODE) {
      return $q.when([]);
    }
    return dataRetriever.retrieveComponentData('service-demand-analysis').then(function (data) {
      return _.uniqBy(data, 'serviceId');
    });
  }
  function getSearchMetaData(screen, mode, selectedEntity) {
    var dataRetriever = competitorFaresCommonService.cloneDataRetriever(screen, mode);
    var originAndDestination = competitorFaresCommonService.getOriginAndDestination(screen, dataRetriever, selectedEntity);
    var departureDate = getDepartureDate(dataRetriever, selectedEntity);
    return $q.all([getTodayDtd(originAndDestination[0], departureDate), getAllServices(dataRetriever, screen, mode), {
      origin: originAndDestination[0],
      destination: originAndDestination[1],
      departureDate: departureDate
    }]).then(function (prevStepResults) {
      return $q.all([prevStepResults, competitorFaresChartTimeWindowService.getCompTimeWindowConfig(prevStepResults[2].origin, prevStepResults[2].destination)]);
    });
  }
  return {
    getSearchMetaData: getSearchMetaData
  };
};
CompetitorFaresChartSearchDataService.$inject = ['$q', 'Restangular', 'DataRetrieverService', 'MomentService', 'DataRetrieverConstantsService', 'DaysToDepartureCalculatorService', 'CompetitorFaresChartTimeWindowService', 'CurrentStateCriteriaService', 'CompetitorFaresCommonService'];
module.exports = CompetitorFaresChartSearchDataService;